import RequestManager from "./RequestManager";
export default new (class AuthServices {
  UserLogin(base, args) {
    return RequestManager.post(base, args);
  }
})();
